import {get} from '../../../components/api/';
import {dashboard} from '../../../constants/url';

function getAttendeds(token: string, cwid: string) {
  const url = `${dashboard}?cwid=${cwid}`;
  return get(url, token);
}

export default getAttendeds;
